/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBadges = createReactComponent("badges", "IconBadges", [
  ["path", { d: "M17 17v-4l-5 3l-5 -3v4l5 3z", key: "svg-0" }],
  ["path", { d: "M17 8v-4l-5 3l-5 -3v4l5 3z", key: "svg-1" }]
]);

export { IconBadges as default };
//# sourceMappingURL=IconBadges.js.map
